const Modal = ({ t, BackButton, setModal }) => {
  return (
    <div className="App-header">
      <div>
        <div
          className="button-primary black-fill button-text-l text-color-pink shadow-pink box-button-center"
          onClick={BackButton}
        >
          {t("leave-room")}
        </div>
        <p className="text-h1 top-margin-l">{t("done1")}</p>
        <p>{t("done2")}</p>
      </div>
      <div
        className="button-primary button-text-l text-color-black shadow-black box-button-center"
        onClick={() => setModal(false)}
      >
        {t("keep-playing")}
      </div>
    </div>
  );
};

export default Modal;
